const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('core/components/video'));
});
